NomenclatureValidator.$inject = ['validator'];

export default function NomenclatureValidator(validator) {
	const instance = new validator();
	return instance;
}
